/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {provisionKeysCashBusinessPayments} from '../api'

export const useMutationProvisionKeysCashBusinessPayments = createReactQueryMutationHook('provisionKeysCashBusinessPayments', provisionKeysCashBusinessPayments)
